<template>
	<div class="block-video" v-if="block.content">
		<figure>
			<iframe  :src="displayVideoSrc(block.content.url)" :title="block.content.caption" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		</figure>
	</div>
</template>

<script>

import scrollBehavior  from '@/mixins/scrollBehavior.js'
import loaderHandler  from '@/mixins/loaderHandler.js'

export default {
	props: ['block','currentLang'],
	mixins: [scrollBehavior, loaderHandler],
	methods:{
		displayVideoSrc(url){
			if(!url){
				return
			}
			const array = url.split('/');
			let finalUrl = 'https://www.youtube.com/embed/ReYTK0_7f5k?controls=0';
			if(array[2] == 'www.youtube.com' || array[2] == 'youtube.com'){
				finalUrl = 'https://www.youtube.com/embed/'+array[3].split('=')[1]+'?controls=0';
			}else if(array[2] == 'vimeo.com' || array[2] == 'www.vimeo.com'){
				finalUrl = 'https://player.vimeo.com/video/'+array[3];
			}
			return finalUrl;
		}
	},
}
</script>

<style lang="scss">
	.block-video figure{
		width: 100%;
		position: relative;
		height:0;
		overflow:hidden;
		padding-bottom:56%;
		iframe{
			position: absolute;
			top:0;
			left:0;
			width:100%;
			height:100%;
		}
	}

	.bloc--regular .block-video{
		max-width:850px;
		margin:auto;
	}
   
</style>